import { render, staticRenderFns } from "./LeisureGameLinks.vue?vue&type=template&id=e0be7ba0&scoped=true&"
import script from "./LeisureGameLinks.vue?vue&type=script&lang=js&"
export * from "./LeisureGameLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0be7ba0",
  null
  
)

export default component.exports